const Circle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    fill="none"
    {...props}
  >
    <rect width={15} height={15} fill="currentColor" rx={14} />
  </svg>
);
export default Circle;
